import React from 'react';
import { IonCol } from '@ionic/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

interface Props {
    children: React.ReactNode;
    title?: string;
    className?: string;
}

const InfoText: React.FC<Props> = ({ children, title, className = '' }) => {
    const { t } = useTranslation();

    return (
        <IonCol size="12" className={className}>
        <div className="border-1 rounded-default border-gray-600 bg-gray-100 p-3 text-sm text-gray-900">
            <div className="flex items-center gap-2">
				<FontAwesomeIcon icon={faInfoCircle} size="lg" />
				{title && <h2 className="text-blue text-lg font-bold">{t(title)}</h2>}
			</div>
            <div className="mt-2">{children}</div>
        </div>
    </IonCol>
    );
};

export default InfoText;